import React, { useState } from 'react';
import { TrendingUp, ArrowDown, ArrowUp, Code, X, Copy } from 'lucide-react';

const PriceCard = ({ type, title, price, change, amount, high, low }) => {
  const [showEmbed, setShowEmbed] = useState(false);
  const isGold = type === 'gold';
  
  // ضبط القيم الافتراضية للحماية
  const safeChange = change || "0%";
  const isPositive = !safeChange.includes('-');
  
  // كود التضمين
  const embedCode = `<iframe src="https://goldpulse.app/widget/${type}" width="300" height="200" frameborder="0"></iframe>`;

  return (
    <div className="flex flex-col w-full relative group">
      {/* المربع الرئيسي - موحد لكل الأنواع */}
      <div className="relative overflow-hidden rounded-[24px] border border-border/40 bg-[#111] p-8 shadow-2xl transition-all duration-300">
        
        {/* خلفية جمالية خفيفة جداً */}
        <div className="absolute top-0 right-0 p-4 opacity-[0.03]">
          <TrendingUp size={120} />
        </div>

        <div className="relative z-10 flex flex-col h-full">
          {/* الرأس: العنوان والدائرة */}
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-sm font-black uppercase tracking-[0.2em] text-muted-foreground mb-1">{title}</h2>
              <span className="text-[10px] font-mono text-muted-foreground/60 bg-white/5 px-2 py-0.5 rounded-md uppercase tracking-widest">Troy Oz</span>
            </div>

            {/* الدائرة: صفراء للذهب | رمادية للفضة */}
            <div className={`p-2 rounded-2xl bg-black/40 border ${isGold ? 'border-[#eab308]/20' : 'border-slate-400/20'}`}>
              <div 
                className={`w-10 h-10 rounded-full shadow-lg transition-transform group-hover:scale-110 duration-500`}
                style={{ 
                  backgroundColor: isGold ? '#eab308' : '#cccccc',
                  boxShadow: isGold ? '0 0 20px rgba(234, 179, 8, 0.3)' : '0 0 20px rgba(148, 163, 184, 0.3)'
                }}
              ></div>
            </div>
          </div>

          {/* السعر الكبير */}
          <div className="mb-6">
            <div className="text-5xl md:text-6xl font-black font-mono tracking-tighter text-white">
              ${price ? price.toLocaleString() : '---'}
            </div>
          </div>

          {/* التغير (المستطيل الملون) */}
          <div className={`flex items-center gap-2 px-4 py-2 rounded-xl border w-fit font-mono text-xs font-bold mb-8
            ${isPositive ? 'bg-green-500/10 border-green-500/20 text-green-500' : 'bg-red-500/10 border-red-500/20 text-red-500'}`}>
            {isPositive ? <ArrowUp size={14} /> : <ArrowDown size={14} />}
            <span>{amount || '$0.00'}</span>
            <span className="opacity-20">|</span>
            <span>{safeChange}</span>
          </div>

          {/* الأعلى والأدنى - خط رفيع وأرقام واضحة */}
          <div className="pt-6 border-t border-white/5 flex items-center justify-between">
            <div className="space-y-1">
              <p className="text-[9px] text-muted-foreground uppercase font-bold tracking-[0.1em]">أعلى اليوم</p>
              <p className="font-mono text-sm text-green-500/80 font-bold">${high || '---'}</p>
            </div>
            <div className="h-8 w-[1px] bg-white/5"></div>
            <div className="space-y-1 text-left">
              <p className="text-[9px] text-muted-foreground uppercase font-bold tracking-[0.1em]">أدنى اليوم</p>
              <p className="font-mono text-sm text-red-500/80 font-bold">${low || '---'}</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* زر التضمين - أسفل الكارت مباشرة */}
      <button 
        onClick={() => setShowEmbed(true)}
        className="flex items-center gap-1.5 text-[9px] font-bold text-muted-foreground/30 mt-3 self-end hover:text-primary transition-all uppercase tracking-widest px-2"
      >
        <Code size={10} /> تضمين في موقعك
      </button>

      {/* النافذة المنبثقة (Popup) */}
      {showEmbed && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center p-4 bg-black/90 backdrop-blur-md">
          <div className="bg-[#151515] border border-white/10 p-8 rounded-[32px] max-w-md w-full shadow-2xl animate-in zoom-in duration-300">
            <div className="flex justify-between items-center mb-6">
              <div className="flex items-center gap-3">
                 <div className="p-2 bg-primary/10 rounded-lg text-primary"><Code size={20}/></div>
                 <h3 className="text-white font-bold text-lg">كود التضمين</h3>
              </div>
              <button onClick={() => setShowEmbed(false)} className="p-2 hover:bg-white/5 rounded-full text-muted-foreground transition-colors"><X size={20}/></button>
            </div>
            <p className="text-xs text-muted-foreground mb-4 leading-relaxed">يمكنك نسخ هذا الكود لإضافة سعر {isGold ? 'الذهب' : 'الفضة'} المباشر إلى موقعك الإلكتروني:</p>
            <div className="bg-black/50 border border-white/5 p-5 rounded-2xl relative">
              <code className="text-[11px] text-primary/80 font-mono break-all block leading-relaxed">{embedCode}</code>
              <button 
                onClick={() => {
                   navigator.clipboard.writeText(embedCode);
                   alert("تم نسخ الكود بنجاح!");
                }}
                className="mt-4 w-full flex items-center justify-center gap-2 py-3 bg-white/5 hover:bg-white/10 text-white rounded-xl text-xs font-bold transition-all border border-white/5"
              >
                <Copy size={14} /> نسخ الكود الآن
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PriceCard;